module.exports = __webpack_public_path__ + "media/images/emblems/Rohrbachgraben-coat_of_arms-9231ef3ad388d7a2e578d7d1bf7a332b.svg";